// extracted by mini-css-extract-plugin
export var contrastLow = "_2u-1";
export var externalLink = "_2u-2";
export var externalLinkIcon = "_2u-3";
export var link = "_2u-0";
export var linkLabel = "_2u-4";